/**
 * Utilitaires pour les cours
 */

/**
 * Vérifie si un cours est gratuit
 */
export function isFreeCourse(course) {
  if (!course) return false
  return course.isFree || course.price === "0" || course.price === 0 || !course.price
}

/**
 * Vérifie si un cours est payant
 */
export function isPaidCourse(course) {
  return !isFreeCourse(course)
}

/**
 * Valide un courseId
 */
export function isValidCourseId(courseId) {
  if (!courseId) return false
  
  // UUID format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  // Numeric ID
  const numericRegex = /^\d+$/
  
  return uuidRegex.test(courseId) || numericRegex.test(courseId)
}

/**
 * Extrait le prix formaté d'un cours
 */
export function getCoursePrice(course) {
  if (isFreeCourse(course)) {
    return { formatted: 'Gratuit', value: 0, currency: null }
  }
  
  return {
    formatted: course.price,
    value: parseFloat(course.price) || 0,
    currency: course.currency || 'XOF'
  }
}

